export class ImageModel {
  imageNo: number;
  title: string;
  description: string;
  link: string;
  thumbLink: string;
  smallLink: string;
  sinkLink: string;
  storedDate: Date;
  convertName: string;
  imageId: string;
  storedFile: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/model/image.model.ts